// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3vexe","icon":"SortAdornment_icon___lSOb","up":"SortAdornment_up__30CtC","down":"SortAdornment_down__2Z-yz","active":"SortAdornment_active__2A-Be"};